// import logo from './logo.svg';
import "./App.css";
import { AuthProvider } from "./Context/AuthContext";
import Routerfile from "./Routerfile";
import { useEffect, useState } from "react";
import axios from "axios";
import FontProvider from "./FontProvider";
const apiUrl = process.env.REACT_APP_API_REST_URL;
function App() {
  const [inspectDisabled, setInspectDisabled] = useState(false);

  useEffect(() => {
    // Fetch inspect status from the backend
    const fetchInspectStatus = async () => {
      try {
        const response = await axios.get(
          `${apiUrl}/CCE/api/v1/commonEngine/inspectStatus`
        );
        const data = response.data;
        if (data.status && data.response && data.response.length > 0) {
          setInspectDisabled(data.response[0].masterValueDesc === "true");
        }
      } catch (error) {
        console.error("Error fetching inspect status:", error);
      }
    };
    fetchInspectStatus();
  }, []);

  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
    const handleKeyDown = (e) => {
      if (e.key === "F12") e.preventDefault(); // Block F12
      if (e.ctrlKey && e.shiftKey && ["I", "C", "J"].includes(e.key)) {
        e.preventDefault(); // Block Ctrl+Shift+I, C, J
      }
      if (e.ctrlKey && e.key === "U") e.preventDefault(); // Block Ctrl+U
    };

    if (inspectDisabled) {
      // Disable right-click
      window.addEventListener("contextmenu", handleContextMenu);
      // Disable F12 and other dev tools
      window.addEventListener("keydown", handleKeyDown);
    }

    // Cleanup event listeners
    return () => {
      window.removeEventListener("contextmenu", handleContextMenu);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [inspectDisabled]);

  useEffect(() => {
    document.body.style.fontFamily = "'Figtree', sans-serif";
  }, []);

  // ----------------------------
  // const [currentForm, setCurrentForm] = useState(1);

  // const changeForm = () => {
  //   setCurrentForm(currentForm + 1);
  // };
  return (
    <FontProvider>
      <AuthProvider>
        <div className="App" style={{ fontFamily: "'Figtree', sans-serif" }}>
          <Routerfile />
        </div>
      </AuthProvider>
    </FontProvider>
  );
}

export default App;
